import React, { useState, useEffect } from "react";
import MarketData from "assets/market_data.png";
import { getAppBaseUrl } from "constants/BaseUrlApp";

export default function HomeGetStarted() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1000);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize on mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        background: "linear-gradient(180deg, #04170D 0%, #123F1F 100%)",
        color: "white",
        borderRadius: "32px",
        display: "flex",
        flexDirection: isMobile ? "column-reverse" : "row",
        alignItems: "center",
        justifyContent: isMobile ? "center" : "flex-start",
        gap: isMobile ? "40px" : "140px",
        height: isMobile ? "auto" : "550px",
        margin: "16px",
        padding: isMobile ? "40px 24px" : "24px 0 0 0",
        overflow: "hidden",
      }}
    >
      <img
        src={MarketData}
        alt="Market Data"
        style={{
          width: isMobile ? "90%" : "35vw",
          height: isMobile ? "auto" : "100%",
          borderRadius: "16px",
          marginTop: isMobile ? "0" : "32px",
          objectFit: "cover",
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: isMobile ? "center" : "flex-start",
          maxWidth: isMobile ? "100%" : "550px",
          textAlign: isMobile ? "center" : "left",
          padding: isMobile ? "0 16px" : "0",
        }}
      >
        <h3
          className="title-cool"
          style={{
            textAlign: isMobile ? "center" : "start",
            fontSize: "2.5rem",
          }}
        >
          Turn Market Data into Informed Decisions
        </h3>
        <p>
          Join a community of ag professionals using Numbersag LLC to stay ahead
          of market trends.
        </p>

        <div
          style={{
            display: "flex",
            gap: "12px",
            marginTop: "16px",
            justifyContent: isMobile ? "center" : "flex-start",
          }}
        >
          <div>
            <button
              className="primary-button secondary-button"
              onClick={() => window.open(getAppBaseUrl())}
            >
              Get started
            </button>
          </div>
          <button
            className="primary-button outline-button"
            onClick={() => window.open("mailto:support@numbers.ag")}
          >
            Contact us
          </button>
        </div>
      </div>
    </div>
  );
}
